module.exports = {
  url: '/offers',
  template: require('raw!templates/offers/offers-view.html'),
  controller: OffersController,
  controllerAs: 'offersCtrl'
};

function OffersController($scope, $state, store, $window, contentful, $http, Socialshare, $document) {
  var vm = this;
  $window.scrollTo(0, 0);
  contentful.entries('content_type=offersPage&sys.id=4mcTySV7wbKBnYIP95OH48').then(function (res) {
    // console.log('meetings page contentful data',res);
    $scope.offers = res.data.items[0];
    console.log('offers page', $scope.offers);
    var seoData = res.data.items[0];
    if (seoData.fields.seoPageTitle) {
      document.title = seoData.fields.seoPageTitle;
    }
    if (seoData.fields.seoPageDescription) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.seoPageDescription;
        }
      }
    }
  });
  setTimeout(function () {
    var elem = document.querySelector('.carousel');
    var flkty = new Flickity(elem, {
      imagesLoaded: true,
      draggable: false,
      percentPostion: false,
      cellAlign: 'center',
      wrapAround: true,
      lazyLoad: true,
      pageDots: false,
      autoPlay: true
    });
  }, 1000);

  vm.trustUrl = "trustUrl";

  trustUrl.$inject = ['$sce'];

  function trustUrl($sce) {
    return function (mediaUrl) {
      return $sce.trustAsResourceUrl(mediaUrl);
    };
  }

  $window.sr = ScrollReveal({
    reset: false
  });
  sr.reveal('.home-load', {
    duration: 1000
  });
  sr.reveal('#cafe', {
    distance: 0,
    duration: 1000,
    scale: 1.5
  }, 500);
  sr.reveal('#pool', {
    distance: 0,
    duration: 1000,
    scale: 1.5
  }, 500);
  sr.reveal('#king-suite', {
    distance: 0,
    duration: 1000,
    scale: 1.5
  }, 500);

  $('.show-blue').on('click', function () {
    var contentID = $(this).data('target');
    $('#' + contentID).toggleClass('reveal');
    $(this).fadeOut(800, 'linear');
  });

  $('.show-white').on('click', function () {
    var contentID = $(this).data('target');
    $('#' + contentID).toggleClass('reveal');
    $(this).fadeOut(800, 'linear');
  });

  // Close overlay when the outside of menu is clicked
  $('.hide-blue').on('click', function () {
    $('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
      $('.overlay.bg-blue').removeClass('conceal');
      $('.overlay.bg-blue').removeClass('reveal');
      $(this).dequeue();
      $(".show-blue").fadeIn(800, 'linear');
    });
  });
  $('.hide-white').on('click', function () {
    $('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
      $('.overlay.bg-white').removeClass('conceal');
      $('.overlay.bg-white').removeClass('reveal');
      $(this).dequeue();
      $(".show-white").fadeIn(800, 'linear');
    });
  });
  vm.socialShare = function (share) {
    if (share === 'facebook') {
      Socialshare.share({
        'provider': 'facebook',
        'attrs': {
          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
          'socialshareQuote': 'Peaks Hotel | Rooms',
          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
          'socialsharePopupHeight': '400',
          'socialsharePopupWidth': '400'
        }
      });
    } else if (share === 'twitter') {
      Socialshare.share({
        'provider': 'twitter',
        'attrs': {
          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
          'socialshareText': 'Peaks Hotel | Rooms',
          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
          'socialsharePopupHeight': '400',
          'socialsharePopupWidth': '400'
        }
      });
    } else if (share === 'pinterest') {
      Socialshare.share({
        'provider': 'pinterest',
        'attrs': {
          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
          'socialshareText': 'Peaks Hotel | Rooms',
          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
          'socialsharePopupHeight': '400',
          'socialsharePopupWidth': '400'
        }
      });
    } else if (share === 'email') {
      Socialshare.share({
        'provider': 'email',
        'attrs': {
          'socialshare-subject': 'Peaks Hotel | Rooms',
          'socialshare-body': 'Take a look at the Peaks Hotel!'
        }
      });
    }
  }
}


// WEBPACK FOOTER //
// ./components/templates/offers/offers-controller.js